import { useEffect } from "react";
import useDataBean from "../../../../../../core/services/dataBean/useDataBean";
import { _single, _UBLInvoice } from "../../../../../../core/services/dataBean/EntityCatalog";
import { ErrorList } from "../../../../../theme/Component/ErrorList";
import { DocumentViewer } from "../../../../../theme/Component/DocumentViewer";
import { Alert } from "../../../../../theme/Component/Alert";


interface Props {
    _idUBLInvoice: number;
    _isseDate: string;
}

export const AccountantDocumentList = ({ _idUBLInvoice, _isseDate }: Props) => {

    const { instance, setLista, lista } = useDataBean(_UBLInvoice);

    useEffect(() => {
        getLista();
    }, [_idUBLInvoice])

    const getLista = () => {
        instance.getAccountantDocumentList(_idUBLInvoice, _isseDate, _single.getAccountID()).then(
            (resp) => {
                console.log(resp)
                setLista(resp);
            }
        ).catch(err => { console.log(err) })
    }

    return (
        <div className="row">
            {lista.map((document: any, idex: number) => {
                return (
                    <div className="col-md-12">
                        {(document.DataBeanProperties.MsgList && document.DataBeanProperties.MsgList.length > 0) &&
                            <ErrorList lista={document.DataBeanProperties.MsgList} />
                        }
                        {(document.DataBeanProperties.DocumentURL && document.DataBeanProperties.DocumentURL.length > 0) &&
                            <DocumentViewer key={document.DataBeanProperties.DocumentURL} list={document.DataBeanProperties.DocumentURL} />
                        }
                    </div>
                )
            })}
            {lista.length === 0 &&
                <div className="col-md-12">
                    <Alert children={"No se encontraron Documentos"} clase="warning" />
                </div>
            }
        </div>
    )

}